import { useState } from "react";
import { FormDialog } from "flux";
import { BaseDialogProps } from "@adora/shared/contexts/dialog-context";
import ModelTraining, { LoraTrainingData } from "../../utils/model-training";
import { Batch } from "@adora/shared/types/batch";
import LoraTrainingForm from "./form";

interface LoraTrainingDialogProps extends BaseDialogProps {
  batch: Batch;
  brandId: number;
}

const LoraTrainingDialog: React.FC<LoraTrainingDialogProps> = ({ batch, open, onClose }) => {
  const [formData, setFormData] = useState<LoraTrainingData>({
    steps: 10,
    loraRank: 8,
    batchSize: 1,
    learningRate: 0.0004,
    optimizer: "adamw8bit",
    resolution: "512,768,1024",
    captionDropoutRate: 0.05,
    themeId: -1,
    contentOrStyle: "balanced",
    wandbSampleInterval: 0,
    wandbSamplePrompt: "",
    baseModelNameOrPath: "",
    trainerName: "default"
  });

  const [submitting, setSubmitting] = useState<boolean>(false);

  const handleLoraTraining = async () => {
    setSubmitting(true);
    const datasetPath = batch.info?.training_dataset_path;

    const { trainLora } = ModelTraining();

    await trainLora({
      brandId: batch.brandId,
      parentBatchId: batch.id,
      ...formData,
      datasetPath
    });

    setSubmitting(false);
    onClose(true);
  };

  return (
    <FormDialog
      title="Train Custom LoRA"
      description="Kick off a job to train a LoRA from a captioned dataset"
      open={open}
      onClose={onClose}
      onSubmit={handleLoraTraining}
      primaryButtonText="Train"
      isPrimaryButtonDisabled={submitting}
      dataDogIdentifier="train custom lora"
    >
      <LoraTrainingForm data={formData} onChange={setFormData} brandId={batch.brandId} />
    </FormDialog>
  );
};

export default LoraTrainingDialog;
